import {Grid, Group, Text} from "@mantine/core";
import {IDescriptionsData} from "./Descriptions.types";
import './styles.scss';

interface Props {
    data: IDescriptionsData[]
}

function Descriptions({data}: Props) {

    return (
        <Grid className='descriptions'>
            {data.map((datum, i) => (
                <Grid.Col span={12} key={datum.title + "title" + i}>
                    <Grid>
                        <Grid.Col className='grid-col-left' span={6}>
                            <Text size="sm" color="gray">{datum.title}</Text>
                        </Grid.Col>
                        <Grid.Col className='grid-col-right' span={6} key={datum.title + "value" + i}>
                            <Text size="sm" color="white">{datum.value}</Text>
                        </Grid.Col>
                    </Grid>
                </Grid.Col>
            ))}
        </Grid>
    )
}

export default Descriptions;